import { Injectable } from '@angular/core';

import { CanActivate, Router } from '@angular/router';

import { GurdServiceService } from './gurd-service.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerGuard implements CanActivate {

  constructor(private _Guard: GurdServiceService, private router: Router) { }

  canActivate(): boolean {

    if (!this._Guard.getToken_2()) {

      this.router.navigateByUrl("/partners");

    }

    return true

  }
  
}
